import React from 'react';
import { Modal } from '@bringg/react-components';
import type { NotificationsTranslation } from '../../components/routes-planner/translations';
import './missing-skills-modal.scss';

interface Props {
	isVisible: boolean;
	onOk: () => void;
	onCancel: () => void;
	translations: NotificationsTranslation;
	missingSkills: string[];
}

const MissingSkillsModal = ({ isVisible, onOk, onCancel, missingSkills, translations }: Props) => {
	return (
		<Modal visible={isVisible} onOk={onOk} onCancel={onCancel} zIndex={1060}>
			<div>{translations.routeNotMatchSkills}</div>
			<div className="skills-list" data-test-id="missingSkillsList">
				{missingSkills.join(', ')}
			</div>
			<div>{translations.recommendChangeDriver}? </div>
		</Modal>
	);
};

export default MissingSkillsModal;
